module.exports = __webpack_public_path__ + "img/project_7.d6eb6353.jpg";